import Vue from 'vue';
import VueRouter from 'vue-router';
import storeOrigin from '../../store';
import { routes } from '../../router';

Vue.use(VueRouter);
export var router = new VueRouter({ routes });
export var store = storeOrigin;
